import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {ItinerariesTasksSettings} from "../../models/itineraries-tasks-settings.model";
import {TaskModel} from "../../../../tasks/models/task.model";
import * as _ from "lodash";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";

require('./agent-itinerary-task-list.scss');
@Component({
  standalone: false,
  selector: 'app-agent-itinerary-task-list',
  templateUrl: './agent-itinerary-task-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentItineraryTaskListComponent implements OnInit, OnChanges {

  @Input() tasks: TaskModel[];
  @Input() agentConfigurationProfile: any;
  @Input() isDisableEntityStateLock: boolean;
  @Input() selectedTaskIds: string[] = [];
  @Input() searchQuery: string;
  @Input() highlightedServiceId: string;
  @Input() itinerariesTaskSettings: ItinerariesTasksSettings;
  @Input() isUseSequence: boolean;

  @Output() onHighlightedChanged = new EventEmitter<any>();
  @Output() onTaskSelectToggle = new EventEmitter<any>();
  @Output() onEditBoundEquipment = new EventEmitter<any>();


  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public toggleRelatedTaskIdsMap: any = {};
  public toggleBundledTaskIdsMap: any = {};

  public selectedTaskItemIds: any;

  constructor() {
  }

  ngOnInit() {
    this.initSelectedTasks();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedTaskIds && !changes.selectedTaskIds.isFirstChange()) {
      this.initSelectedTasks();
    }
  }

  onClickRelatedTaskListToggle(taskId: string) {
    this.toggleRelatedTaskIdsMap[taskId] = !this.toggleRelatedTaskIdsMap[taskId];
  }

  onClickBundledTaskListToggle(taskId: string) {
    this.toggleBundledTaskIdsMap[taskId] = !this.toggleBundledTaskIdsMap[taskId];
  }

  getTaskNumber(task) {
    if (!this.tasks) {
      return;
    }
    return this.tasks?.findIndex(t => t.id === task.id) + 1;
  }

  private initSelectedTasks() {
    this.selectedTaskItemIds = {};
    _.forEach(this.selectedTaskIds, (selectedTaskId) => {
      this.selectedTaskItemIds[selectedTaskId] = true;
    });
  }

}
